import React from "react";
import "./ErrorLabel.css";

const ErrorLabel = ({ ErrorDisplay, color, id }) => {
  const Color = color === true ? "success" : "star-required";
  return (
    <>
      <p className="error-p">
        <span
          id={id}
          className={`${Color} Errlabel-font_size`}
          style={{ minHeight: "26px" }}
        >
          {ErrorDisplay}
        </span>
      </p>
    </>
  );
};

export default ErrorLabel;
